module.exports = ('withCredentials' in new XMLHttpRequest());
